import { render } from "./SignUp.vue?vue&type=template&id=0eee3960"
import script from "./SignUp.vue?vue&type=script&lang=js"
export * from "./SignUp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__